<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <!-- THIN -->
        <path
            v-if="weight === 'THIN'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.9241 16.8243C20.6898 17.0586 20.3099 17.0586 20.0756 16.8243L11.9999 8.74853L3.92412 16.8243C3.6898 17.0586 3.3099 17.0586 3.07559 16.8243C2.84127 16.5899 2.84127 16.2101 3.07559 15.9757L11.5756 7.47574C11.8099 7.24142 12.1898 7.24142 12.4241 7.47574L20.9241 15.9757C21.1584 16.2101 21.1584 16.5899 20.9241 16.8243Z"
            fill="currentColor"
        />

        <!-- REGULAR -->
        <path
            v-else-if="weight === 'REGULAR'"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.0657 17.0655C20.7533 17.3779 20.2468 17.3779 19.9344 17.0655L12 9.13118L4.06573 17.0655C3.75331 17.3779 3.24678 17.3779 2.93436 17.0655C2.62194 16.7531 2.62194 16.2465 2.93436 15.9341L11.4344 7.43412C11.7468 7.1217 12.2533 7.1217 12.5657 7.43412L21.0657 15.9341C21.3782 16.2465 21.3782 16.7531 21.0657 17.0655Z"
            fill="currentColor"
        />

        <!-- FILL -->
        <path
            v-else
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.2071 17.2071C20.8166 17.5976 20.1834 17.5976 19.7929 17.2071L12 9.41421L4.20711 17.2071C3.81658 17.5976 3.18342 17.5976 2.79289 17.2071C2.40237 16.8166 2.40237 16.1834 2.79289 15.7929L11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289L21.2071 15.7929C21.5976 16.1834 21.5976 16.8166 21.2071 17.2071Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
    export default {
        name: 'expand-less-icon',
        props: {
            width: {
                type: [String, Number],
                default: 24,
            },
            height: {
                type: [String, Number],
                default: 24,
            },
            color: {
                type: String,
                default: 'text-black',
            },
            weight: {
                type: String,
                default: 'THIN',
                validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
            },
        },
    };
</script>
